import utils from "utils";

class faq {
  constructor(elem) {
    this.elem = elem;
    this.form = document.querySelector(".faq-search-form");
    this.search = this.form.querySelector(".form-text");
    this.start = this.elem.querySelector(".faq__start");
    this.buttons = this.elem.querySelectorAll(".faq__button");
    this.rows = this.elem.querySelectorAll(".faq__row");
    this.sibluFaq();
  }

  sibluFaq() {
    this.elem.classList.add("js-processed");

    if (this.start && this.buttons.length && this.rows.length) {
      this.search.addEventListener("focus", () => {
        if (document.body.getAttribute("faq-search-start") === null) {
          document.body.setAttribute("faq-search-start", true);
        }
      });

      if (document.body.getAttribute("faq-search-start") !== null) {
        window.setTimeout(() => {
          this.focusEndLine(this.search);
        }, 1);
      }

      this.elem.classList.remove("faq--no-results");
      this.rows.forEach((row, i) => {
        row.setAttribute("data-index", i + 1);

        const back = row.querySelector(".faq__back");

        if (back) {
          back.addEventListener("click", () => {
            if (this.elem.classList.contains("active")) {
              this.elem.classList.remove("active");
              const activeButton = this.elem.querySelector(
                ".faq__button.active"
              );
              if (activeButton) {
                activeButton.classList.remove("active");
              }
              const activeRow = this.elem.querySelector(".faq__row.active");
              if (activeRow) {
                activeRow.classList.remove("active");

                activeRow
                  .querySelectorAll("details[open]")
                  .forEach((details) => {
                    details.open = false;
                  });
              }
            }
          });
        }
      });

      this.buttons.forEach((button, i) => {
        button.setAttribute("data-index", i + 1);
        this.start.appendChild(button);

        const row = this.elem.querySelector(
          `.faq__row[data-index="${button.getAttribute("data-index")}"]`
        );

        button.addEventListener("click", () => {
          if (!button.classList.contains("active")) {
            const activeButton = this.elem.querySelector(".faq__button.active");
            if (activeButton) {
              activeButton.classList.remove("active");
            }
            const activeRow = this.elem.querySelector(".faq__row.active");
            if (activeRow) {
              activeRow.classList.remove("active");

              activeRow.querySelectorAll("details[open]").forEach((details) => {
                details.open = false;
              });
            }
            button.classList.add("active");
            if (!this.elem.classList.contains("active")) {
              this.elem.classList.add("active");
            }
            row.classList.add("active");
          }
        });
      });

      if (!utils.mq.md.matches) {
        this.elem.classList.add("active");
        this.buttons[0].classList.add("active");
        this.rows[0].classList.add("active");
      }

      utils.mq.md.addEventListener("change", (e) => {
        if (!e.matches && !this.elem.classList.contains("active")) {
          this.elem.classList.add("active");
          this.buttons[0].classList.add("active");
          this.rows[0].classList.add("active");
        }
      });
    } else {
      this.elem.classList.add("faq--no-results");
      window.setTimeout(() => {
        this.focusEndLine(this.search);
      }, 1);
    }
  }

  focusEndLine(input) {
    const end = input.value.length;
    input.setSelectionRange(end, end);
    input.focus();
  }
}

/* LISTEN FOR RELOAD AFTER AJAX CALL */
document.addEventListener(
  "reloadFAQMenuSection",
  (e) => {
    const faqElems = document.querySelectorAll(".faq:not(.js-processed)");
    for (let faqElem of faqElems) {
      faqElem.faq = new faq(faqElem);
    }
  },
  false
);
